<!--
 * @Description: 关于我们 header video
 * @Author: mileS
 * @Date: 2020-06-10 16:22
 * @LastEditTime: 2020-06-10 16:22
 * @LastEditors: 2020-06-10 16:22
 -->
<template>
  <div class="header">
    <p class="title download-cn">关于未来魔法校</p>
    <p class="title download-en">ABOUT ME</p>
    <video class="video-box" muted loop autoplay="autoplay">
      <source :src="videoUrl" type="video/mp4">
    </video>
    <img src="../../../assets/pngs/play-btn.png" class="play-btn" @click="playVideo = true"/>
    <div v-if="playVideo" class="video-player">
      <img class="icon-close" @click="playVideo = false" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-close.png">
      <Xgplayer :config="videoConfig" @player="Player = $event"/>
    </div>
  </div>
</template>

<script>
import { video } from '../assets/data'
import Xgplayer from 'xgplayer-vue'
export default {
  components: { Xgplayer },
  data () {
    return {
      videoUrl: video, // 视频地址
      playVideo: false, // 视频显示开关
      videoConfig: { // 视频播放配置
        id: 'vs',
        url: video,
        width: 1106,
        height: 620,
        autoplay: true
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .header{
    margin: 80px auto 0;
    position: relative;
    height: 420px;
    width: 1280px;
    .video-box{
      object-fit: fill;
      position: absolute;
      top: 170px;
      left: 86px;
      right: 0;
      padding: 6px;
      background-color: #ffffff;
      width: 1106px;
      border-radius:4px;
      /*height: 488px;*/
    }
    .play-btn{
      position: absolute;
      top: 480px;
      width: 88px;
      height: 88px;
      left: 50%;
      margin: -44px 0 0 -44px;
      cursor: pointer;
    }
    .video-player{
      position: absolute;
      width: 1106px;
      height: 620px;
      top: 163px;
      left: 86px;
      z-index: 200;
      .icon-close{
        position: absolute;
        top: -45px;
        right: -45px;
        width: 45px;
        height: 45px;
        cursor: pointer;
      }
      ::v-deep .xgplayer-skin-default{
        .xgplayer-start{
          width: 88px;
          height: 88px;
          border-radius: 50%;
          background: url(https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-play.png);
          background-size: 100% 100%;
          margin: -35px auto auto -35px;
          .xgplayer-icon-play{
            display: none;
          }
        }
      }
    }
    .title{
      position: absolute;
      left: 80px;
      &.download-cn{
        top: 40px;
        font-size:40px;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:56px;
      }
      &.download-en{
        top: 76px;
        font-size:56px;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:78px;
        opacity: 0.1;
      }
    }
  }
</style>
